import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdvMessageService, LocalizationService, LoginStatus, verificationCodeModel, VerificationType } from 'projects/shared/src/public-api';
import { AppAuthService } from '../../../kesher-shared/services/app-auth.service';
import { LoginBySessionModel, LoginBySessionStatus } from '../../model/loginBySession.model';

@Component({
  selector: 'app-login-by-session',
  templateUrl: './login-by-session.component.html',
  styleUrls: ['./login-by-session.component.scss']
})
export class LoginBySessionComponent implements OnInit {
  sessionId: string;
  message: string;
  verificationCodeDetails: verificationCodeModel;
  verificationCode;

  constructor(private activateRoute: ActivatedRoute, private router: Router, private localizationService: LocalizationService,
    private messagesService: AdvMessageService, private authService: AppAuthService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.activateRoute.params.subscribe(params => {
      this.sessionId = params["sessionId"];
      if (!this.sessionId) {
        this.errorAndExit();
        return;
      }
      this.login({ sessionId: this.sessionId, verificationCode: null, status: LoginBySessionStatus.SendVerification });
    });
  }

  verificationOk() {
    this.login({ sessionId: this.sessionId, verificationCode: this.verificationCode, status: LoginBySessionStatus.CheckVerification });
  }

  onVerificationCodeCancel() {
    this.verificationCodeDetails.verificationCodeSend = false;
    this.router.navigate(["/login"]);
  }

  sendAgainVerificationCode() {
    this.login({ sessionId: this.sessionId, verificationCode: null, status: LoginBySessionStatus.SendVerification });
  }

  login(loginModel: LoginBySessionModel) {
    if (!loginModel || !loginModel.sessionId)
      this.errorAndExit();


    this.authService.loginBySession(loginModel).subscribe(response => {
      let errorMessage = null;
      let exit = true;
      switch (response.Status) {
        case LoginStatus.Succeeded:
          let companyCode = response.Company.CompanyCode;
          this.router.navigate([`kesher/${companyCode}/home`]);
          break;
        case LoginStatus.InvalidVerificationCode:
          errorMessage = this.localizationService.Translate("LOGIN.MESSAGES.INVALID_VERIFICATION_CODE");
          exit = false;
          break;
        case LoginStatus.InvalidLogin:
          errorMessage = this.localizationService.Translate("LOGIN.MESSAGES.INVALID_LOGIN_BY_SESSION");
          break;
        case LoginStatus.BlockedSystem:
          errorMessage = this.localizationService.Translate("LOGIN.MESSAGES.BLOCKED_SYSTEM");
          break;
        case LoginStatus.VerificationCodeSent:
          this.verificationCodeDetails = {
            verificationCodeSend: true,
            encryptedNumMailOrPhone: response.EncryptedNumMailOrPhone,
            verificationType: VerificationType.Phone
          };
          break;
        default:
          errorMessage = this.localizationService.Translate("ERROR_MESSAGES.UNKNOWN_ERROR");
          break;
      }
      this.cd.detectChanges();

      if (errorMessage) {
        this.errorAndExit(errorMessage, exit);
      }

    });
  }

  errorAndExit(errorMessage = null, exit = true) {
    if (!errorMessage)
      errorMessage = this.localizationService.Translate("LOGIN.MESSAGES.GENERAL_ERROR");;
    this.messagesService.errorMessage(errorMessage, 2000);
    if (exit)
      this.router.navigate(["/login"]);
  }

}
